// extracted by mini-css-extract-plugin
export default {"imgdiv":"_24edc98f56 _4f0d18b79a","img":"_812fe5fbe3 _61c4fd1ede"};